/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import FormGroup from '@material-ui/core/FormGroup/index'
import Checkbox from '@material-ui/core/Checkbox/index'
import parse from 'html-react-parser'

import { Grid, FormControl, FormLabel, FormControlLabel, FormHelperText, Typography } from '@material-ui/core'

const styles = theme => ({
    formControl: {
        margin: theme.spacing(0)
    },
    buttons: {
        position: 'relative'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5)
    },
    radio: {
        minWidth: '110px',
        alignItems: 'start'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        width: '100%'
    },
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    lgTitle: {
        fontSize: '1.5rem',
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.primary,
        lineHeight: 1.15
    },
    customTitleSize: {
        marginTop: 0
        //textAlign: 'left!important'
    },
    optionHelper: {
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    checkboxOptionHelper: {
        marginTop: 0 + 'px!important',
        marginBottom: theme.spacing(2) + 'px!important',
        paddingLeft: '36px!important',
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    label: {
        marginBottom: theme.spacing(1.5) + 'px!important'
    },
    group: {
        marginTop: 15
    },
    buttonWithoutImage: {
        padding: 6
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '0px 4px 4px 4px!important'
        }
    },
    checkbox: {
        color: theme.palette.primaryColor + '!important'
    },
    helperText: {
        marginTop: theme.spacing(1.5),
        fontSize: '0.875rem',
        color: theme.palette.text.primary,
        lineHeight: 1.43
    },
    description: {
        marginTop: 16
    }
})

class CheckboxesQuestion extends Component {
    state = {
        checkboxValues: []
    }

    componentDidMount() {
        if (this.props.value) {
            this.initCheckboxValues(this.props.value)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.initCheckboxValues(nextProps.value)
        }
    }

    initCheckboxValues(values) {
        this.setState({ checkboxValues: values.map(String) })
    }

    handleChange = (value, checked = null) => {
        if (checked !== null) {
            let checkboxValues = this.state.checkboxValues
            if (checked === false) {
                checkboxValues = checkboxValues.filter(x => x !== value)
            } else {
                checkboxValues.push(value)
            }
            this.setState({ checkboxValues: checkboxValues })
            value = checkboxValues
        }
        this.props.onValueChanged(this.props.question.id, value)
    }

    isChecked(value) {
        return this.state.checkboxValues.indexOf(value.toString()) !== -1
    }

    render() {
        const { classes, question, value } = this.props
        return (
            <>
                <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper}>
                    <FormControl component="fieldset" className={classes.formControl} fullWidth style={{ marginTop: 0 }}>
                        {question.title && (
                            <>
                                {!question.titleSize && <FormLabel component="legend">{question.title}</FormLabel>}
                                {question.titleSize && (
                                    <Typography variant={question.titleSize} gutterBottom className={classes.customTitleSize}>
                                        {question.title && parse(question.title)}
                                    </Typography>
                                )}
                            </>
                        )}
                        {question.description && (
                            <Typography component="span" variant="body1" className={classes.description}>
                                {parse(question.description)}
                            </Typography>
                        )}
                        <FormGroup
                            row
                            aria-label={question.title}
                            name={question.name}
                            className={classes.group}
                            value={String(this.state.value)}
                            onChange={event => this.handleChange(event.target.value, event.target.checked)}
                        >
                            <Grid container spacing={1}>
                                {question.options &&
                                    question.options.map((option, key) => {
                                        return (
                                            <Grid
                                                item
                                                xs={parseInt(option.xsCols)}
                                                sm={parseInt(option.smCols)}
                                                key={key}
                                                style={{ paddingBottom: 0 }}
                                            >
                                                <FormControlLabel
                                                    value={option.value && String(option.value)}
                                                    control={
                                                        <Checkbox
                                                            color="primary"
                                                            classes={{ root: classes.checkbox }}
                                                            checked={this.isChecked(option.value)}
                                                        />
                                                    }
                                                    label={parse(option.label)}
                                                    className={classes.checkbox}
                                                    key={key}
                                                />

                                                {option.description && (
                                                    <FormHelperText className={classes.checkboxOptionHelper}>{option.description}</FormHelperText>
                                                )}
                                            </Grid>
                                        )
                                    })}
                            </Grid>
                        </FormGroup>
                        {question.valid === false && (
                            <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                            </Grid>
                        )}
                        {question.helperText && (
                            <Grid>
                                <FormHelperText className={classes.helperText}>{parse(question.helperText)}</FormHelperText>
                            </Grid>
                        )}
                    </FormControl>
                </Grid>
            </>
        )
    }
}

export default withStyles(styles)(CheckboxesQuestion)
